import { IntlShape } from 'react-intl';

// Non-TH doesn't display an error
// eslint-disable-next-line
export const getBillingCountryError = (_: IntlShape['formatMessage']) => '';
